/* src/app/views/admin/chat/chat.component.css */
.send-btn {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
/*# sourceMappingURL=chat.component.css.map */
